export const IS_STORYBOOK = typeof window !== 'undefined' && (window as { IS_STORYBOOK?: boolean }).IS_STORYBOOK;
export const MOBILE_STICKY_OFFSET = IS_STORYBOOK ? 0 : 60;
